export interface SignValueMap<T> {
	positive: T;
	negative: T;
	zero: T;
	/**
	 * If not given, uses the `zero` value.
	 */
	undefined?: T;
}

export function signDependentValue<T>(
	value: number | undefined,
	mapping: SignValueMap<T>
): T {
	if (value === undefined) {
		return mapping.undefined ?? mapping.zero;
	}

	if (value > 0) {
		return mapping.positive;
	}

	if (value < 0) {
		return mapping.negative;
	}

	return mapping.zero;
}
